import { Redirect } from 'expo-router';
import Head from 'expo-router/head';
import { useIntl } from 'react-intl';

import { VisuallyHiddenH1 } from '@fhs/ui';
import AuthHome from '@fhs-legacy/frontend/src/pages/authentication/auth-home';
import { AuthMethod } from '@fhs-legacy/frontend/src/pages/authentication/auth-home/types';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function SigninPage() {
  const { formatMessage } = useIntl();
  const enableSimplyAuth = useFlag('enable-simply-auth-flow');

  return !enableSimplyAuth ? (
    <>
      <Head>
        <title>{`${formatMessage({ id: 'signIn' })} - Firehouse Subs`}</title>
      </Head>
      <VisuallyHiddenH1 title={formatMessage({ id: 'signIn' })} />
      <AuthHome method={AuthMethod.SIGN_IN} />
    </>
  ) : (
    <Redirect href="/v2/signin" />
  );
}
